import { useIsWebview } from '~/scopes/webviews/useIsWebview'

import type { useJSBridge } from './useJSBridge'

export function useShoppingAssistantActions(
  bridge: ReturnType<typeof useJSBridge> | undefined,
) {
  const isWebview = useIsWebview()

  function close() {
    if (isWebview) bridge?.closeWebview()
  }

  function newChat(dialog: {
    title: string
    description: string
    acceptButtonText: string
    declineButtonText: string
    onAccept: () => void
    onDecline?: (() => void) | undefined
  }) {
    if (isWebview) {
      bridge?.showDialog(dialog)
    } else {
      dialog.onAccept()
    }
  }

  function addToCart() {
    if (isWebview) {
      bridge?.addToCart()
    }
  }

  return {
    close,
    newChat,
    addToCart,
  }
}
